import { useIntl } from "react-intl";

import Input from "components/v2/Input/Input";
import FormSectionLabel from "pages/shipper/RequestFormV2/components/FormSectionLabel/FormSectionLabel";
import { FIELD_TEST_ID_OVERRIDES } from "@RequestFormV2/utils/testIds";
import { useOrganisation } from "@RequestFormV2/sections/Organisation/context";
import CostRecoveryFields from "@RequestFormV2/sections/Organisation/components/ShipmentDetailsSection/CostRecoveryFields";
import OrganisationCustomFields from "@RequestFormV2/sections/Organisation/components/ShipmentDetailsSection/OrganisationCustomFields";

export default function ShipmentDetailsSection() {
  const intl = useIntl();
  const { organisationFields, shipmentTitleDetails } = useOrganisation();
  const hasOrganisationFields = Boolean(organisationFields?.length);

  const shipmentTitleLabel =
    shipmentTitleDetails?.label ||
    intl.formatMessage({
      id: "request-form.organisation.shipment-title",
      defaultMessage: "Shipment title",
    });

  const shipmentTitleRequired = shipmentTitleDetails?.mandatory === true;

  return (
    <div className="rfv2-form-section">
      <FormSectionLabel
        label={intl.formatMessage({
          id: "request-form.organisation.shipment-details",
          defaultMessage: "Shipment details",
        })}
      />

      <div className="rfv2-form-section__content">
        {hasOrganisationFields && (
          <Input
            name="shipment.title"
            label={shipmentTitleLabel}
            required={shipmentTitleRequired}
            testId={FIELD_TEST_ID_OVERRIDES.shipment_title}
          />
        )}

        <OrganisationCustomFields />
        <CostRecoveryFields />
      </div>
    </div>
  );
}
